'use strict';

class MobileSeries
{

    constructor()
    {
        this.primary  = $('.js-series-element-mobile-primary');
        this.element  = $('.js-series-element').not('.js-series-element-mobile-primary');
        this.elements = $('.js-series-element');
        this.window   = $(window);
        this.bindEvents();
    }

    bindEvents()
    {
        this.window.on('load resize', this.checkClick.bind(this));
        this.window.on('resize', this.sortElements.bind(this));
        this.element.on('click', this.moveElement.bind(this));
    }

    moveElement(e)
    {
        e.preventDefault();
        if ( !this.clickAllowed ) return false;
        let el = $(e.currentTarget);

        const elementInfo = this.getElementData(el);
        const primaryInfo = this.getElementData(this.primary);

        this.setElementData(el, primaryInfo);
        this.setElementData(this.primary, elementInfo);
    }

    setElementData(element, data)
    {
        element.find('.js-series-element-image').attr({
            'src'    : data.src,
            'srcset' : data.srcset
        });
        element.find('.js-series-element-title').text(data.title);
        element.find('.js-series-element-description').html(data.description);
    }

    getDefaultElementData(element)
    {
        return {
            src         : element.attr('data-series-src'),
            srcset      : element.attr('data-series-srcset'),
            title       : element.attr('data-series-title'),
            description : element.attr('data-series-description')
        }
    }

    getElementData(element)
    {
        const image = element.find('.js-series-element-image');

        return {
            src         : image.attr('src'),
            srcset      : image.attr('srcset'),
            title       : element.find('.js-series-element-link .js-series-element-title').text(),
            description : element.find('.js-series-element-description').html()
        }
    }

    checkClick()
    {
        if ( window.deviceWidth <= APP.tabletXsWidth ) {
            this.clickAllowed = true;
        } else {
            this.clickAllowed = false;
        }
    }

    sortElements()
    {
        if ( !this.clickAllowed )
        {
            this.elements.each($.proxy(function (i, element ) {

                const defaultInfo = this.getDefaultElementData($(element));
                const info        = this.getElementData($(element));

                if (defaultInfo.src != info.src)
                {
                    this.setElementData($(element), defaultInfo);
                }

            }, this));
        }
    }
}